import { Component, Input, OnInit } from '@angular/core';
import { IVerifyCodeRequest } from '../../classes/http-requests';
import {
	ISendUnlockEmailRequest,
	ISendUnlockEmailResponse,
	SendUnlockEmailRequest,
	SendUnlockEmailResponse,
	UnlockAcountEmail,
} from '../../classes/unlock-account-email';
import { finalize } from 'rxjs/operators';
import { ComponentWithErrors } from '../../classes/component-with-errors';
import { IUserData } from '../../../globals/classes/userData';
import { GoogleAnalyticsUtils } from '../../classes/static/google-analytics-utils';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'user-code-corporate',
	template: require('./user-code-corporate.component.html'),
})
export class UserCodeCorporateComponent extends ComponentWithErrors implements OnInit {
	@Input() verfiyCodeRequest: IVerifyCodeRequest;
	@Input() public userData: IUserData;
	public isRebrading = AppSettings.isRebrading;
	public loading: boolean = false;
	public sendUnlockEmailResponse: ISendUnlockEmailResponse;

	constructor() {
		super();
	}

	ngOnInit(): void {
		this.setDynatraceEvent('IB_PR_Enter_Email_Code');
	}

	public resend() {
		this.loading = true;
		let request: ISendUnlockEmailRequest = new SendUnlockEmailRequest();
		request.userId = this.userData.userId;
		request.resend = true;
		UnlockAcountEmail.sendUnlockEmail(request)
			.pipe(finalize(() => (this.loading = false)))
			.subscribe(
				(res) => {
					this.resolveSendEmailResponse(res);
				},
				(error) => {
					this.handleError();
				}
			);
	}

	public resolveSendEmailResponse(response: ISendUnlockEmailResponse) {
		if (response && response != null) {
			this.sendUnlockEmailResponse = new SendUnlockEmailResponse(response);
			if (this.sendUnlockEmailResponse.succeeded) {
				GoogleAnalyticsUtils.sendRetrievePasswordStep2();
			}
		}
	}
}
